import React from 'react';
import InvitationForm from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/components/invitation-form';
import If from 'components/if-statement';
import { withModal } from 'hoc';
import { ModalContext } from 'hoc/with-modal';

export interface ShareSurfaceModalProps {
  modal: ModalContext;
  data: any;
}

const defaultProps = {};

function ShareSurfaceModal(props: ShareSurfaceModalProps) {
  const [areInvitationsSent, setInvitationsSent] = React.useState(false);

  function onSubmitSuccess() {
    setInvitationsSent(true);
  }

  return (
    <If condition={areInvitationsSent}>
      <If.Then>
        <></>
      </If.Then>
      <If.Else>
        <InvitationForm {...props} onSubmitSuccess={onSubmitSuccess} />
      </If.Else>
    </If>
  );
}

ShareSurfaceModal.defaultProps = defaultProps;

export default withModal(ShareSurfaceModal);
